import { ITypedReduxAction } from '../../types/redux/actionType';
import { TUser } from '../../types/currentUser';
import { actionGenerator } from '../../utils/redux/actionGenerator';

export enum EGetUserStatus {
  Initial = 'USER/INITIAL',
  Loading = 'USER/LOADING',
  Succeed = 'USER/SUCCEED',
  Failed = 'USER/FAILED',
}

export type TGetUserLoading = ITypedReduxAction<EGetUserStatus.Loading>;
export type TGetUserSucceed = ITypedReduxAction<EGetUserStatus.Succeed, TUser>;
export type TGetUserFailed = ITypedReduxAction<EGetUserStatus.Failed>;

export type TUserActions = TGetUserLoading | TGetUserSucceed | TGetUserFailed;

export const setStatusSucceed = actionGenerator<EGetUserStatus.Succeed, TUser>(EGetUserStatus.Succeed);
